import React, { Component } from 'react'
import './leave.css'
import IconButton from '@mui/material/IconButton';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { Spinner, Modal } from 'react-bootstrap'
import Swal from 'sweetalert2'
import VisibilitySensor from 'react-visibility-sensor';
import { confirmAlert } from 'react-confirm-alert'
import { Table } from 'react-bootstrap'
import { DateTime } from 'luxon';
import { LuPlus } from "react-icons/lu";
import GetImage from '../../components/getimage/Getimage';
import Hexapi from '../../utility/HexAPI/Hexapi';
import TimeFormatter from '../../utility/TimeFormatter';
import Empmodal from '../../components/empmodal/Empmodal';
import InputBox from '../../components/formcontrols/normal/InputBox';
import { Datetimepicker } from '../../components/calendar/Calender'
import withRouter from '../../utility/withRouter';
import { decodeUrl } from '../../utility/decodesearchurl';
import { showConfirm } from '../../utility/showconfirm';
import Loader from '../../components/loader/Loader';
 class Leave extends Component {
    constructor(props) {
        super(props)
        const getUrlEmpid = (search,props) => {
            if(window.location.search.includes("?")){
   const urlParams = decodeUrl(search);
            const empid = urlParams.id
            if (empid != -1) {
                return empid
            } else {
                return props.userid
            }
            }else {
                return props.userid
            }
        }
        const getUrlUserName = (search,props) => {
             if(window.location.search.includes("?")){
           const urlParams = decodeUrl(search);
            const name = urlParams.name
            console.log(name, "urlname")
            if (name) {
                return name
            } else {
                return props.username
            }}else {
                return props.username
            }
        }

        this.state = {
            EmpID: getUrlEmpid(window.location.search,props),
            defaultEmpid: getUrlEmpid(window.location.search,props),
            action: -1,
            Username: getUrlUserName(window.location.search,props),
            userid: this.props.userid,
            headers: {
                Leave: ["Remarks", 'Employee', 'Leave Type', 'Time', 'Reason', 'Substitute', "Duration", ""]
            },
            isApiHitComplete: false, isLeaveListFound: false,
            allLeaves: [], AllLeaveTypes: [], AllApprovers: [],
            isOpenAddLeaveModal: false, isModalLoading: false,
            selectedLeaveTypeName: '', reason: '', selectedApproverName: '', selectedApproverId: '',
            selectedToDateString: '', selectedToDateLogTime: '-1', selectedFromDateString: '', selectedFromDateLogTime: '-1',
            selectedLeaveTypeID: '', shiftDetails: [], openFromdatamodal: false, opentodatamodal: false,
            OLCmsg: '--', isOLCapihitcomplete: true, isApproverListDisable: false, isOpenApproversListModal: false,
            isLastList: false, leaveListLength: 0,
            timezone: "",
            selectedLeaveforName: "",
            selectedLeaveforID: "",
            isOpenleaveforListModal: false,
            leaveforlist: [],
            opensubstitutemodal: "",
            substitutelist: [],
            selectedsubstituteName: "",
            selectedsubstituteID: "",
            
        }
        this.getLeaveList = this.getLeaveList.bind(this)
        this.closeApplyLeaveModal = this.closeApplyLeaveModal.bind(this)
        this.openLeaveTypeModal = this.openLeaveTypeModal.bind(this)
        this.setFullDateString = this.setFullDateString.bind(this)
        this.setActionMessage = this.setActionMessage.bind(this)
        this.Addleave = this.Addleave.bind(this)
        this.storeFromDate = this.storeFromDate.bind(this)
        this.storeToDate = this.storeToDate.bind(this)
        this.setOLC = this.setOLC.bind(this)
        this.setLeaveType = this.setLeaveType.bind(this)
        this.openApproverList = this.openApproverList.bind(this)
        this.submitLeave = this.submitLeave.bind(this)
        this.DeleteLeave = this.DeleteLeave.bind(this)
        this.getHeader = this.getHeader.bind(this)
        this.setRowsFromHeaders = this.setRowsFromHeaders.bind(this)
        this.convertShiftTime = this.convertShiftTime.bind(this)
        this.convertToIndianTime = this.convertToIndianTime.bind(this)
        this.setLeavefor = this.setLeavefor.bind(this)
        this.setsubstitute = this.setsubstitute.bind(this)
        this.getTimezoneString = this.getTimezoneString.bind(this)
        this.getUTCOffset = this.getUTCOffset.bind(this)
        this.opensubstituteList = this.opensubstituteList.bind(this)
        this.convertToFullDateTime = this.convertToFullDateTime.bind(this)
        this.getaction = this.getaction.bind(this)
        this.updateHeader=this.updateHeader.bind(this)
    }
    opensubstituteList() {
        this.setState({
            opensubstitutemodal: true
        })
    }
    getaction = (search) => {
        console.log(search, "name")
         if(window.location.search.includes("?")){
             const urlParams = decodeUrl(search);
             const action = urlParams.action
    
        if (action) {
            return this.setState({
                action: action
            })
        } else {
            return -1
        }
         }else{
            return -1
         }
        
    }
    convertToFullDateTime(checkInMinutes, timeZone) {
        const timeZoneName = timeZone.split(' ')[0];
        const baseDate = DateTime.utc().plus({ days: 1 }).startOf('day');
        const checkInTimeUTC = baseDate.plus({ minutes: checkInMinutes });
        const checkInTimeInZone = checkInTimeUTC.setZone(timeZoneName, { keepLocalTime: true });
        const formattedCheckInTimeInZone = checkInTimeInZone.toFormat('yyyy-LL-dd HH:mm:ss');
        // console.log(formattedCheckInTimeInZone, "formatted");
        return formattedCheckInTimeInZone;
    }

    getUTCOffset(targetTimezoneString) {
        if (targetTimezoneString !== '') {
            const utcMatch = targetTimezoneString.match(/UTC\s?([-+]\d+):(\d+)/);
            // console.log(utcMatch,"utcmatch")
            return utcMatch[0]
        }

    }
    getUTCFromTimezone(timezone) {
        const utcMatch = timezone.match(/UTC\s?([-+]\d+):(\d+)/);
        return utcMatch[0]
    }

    getTimezoneString() {
        const offset = new Date().getTimezoneOffset();
        const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
        const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
        const sign = offset <= 0 ? "+" : "-";
        return `UTC ${sign}${hours}:${minutes}`;
    }


    convertToIndianTime(currentShiftTime, sourceTimezoneString) {

        const utcMatch = sourceTimezoneString.match(/UTC\s?([-+]\d+):(\d+)/);
        if (!utcMatch) {
            throw new Error("Invalid timezone string format");
        }
        const sourceHoursOffset = parseInt(utcMatch[1], 10);
        const sourceMinutesOffset = parseInt(utcMatch[2], 10);
        const sourceTotalOffsetMinutes = sourceHoursOffset * 60 + sourceMinutesOffset;
        const indianOffsetMinutes = 5 * 60 + 30;
        const sourceDate = new Date(currentShiftTime);
        const shiftUTC = sourceDate.getTime() - sourceTotalOffsetMinutes * 60000;
        const indianShiftTime = new Date(shiftUTC + indianOffsetMinutes * 60000);
        const year = indianShiftTime.getFullYear();
        const month = String(indianShiftTime.getMonth() + 1).padStart(2, '0');
        const day = String(indianShiftTime.getDate()).padStart(2, '0');
        const hours = String(indianShiftTime.getHours()).padStart(2, '0');
        const minutes = String(indianShiftTime.getMinutes()).padStart(2, '0');
        const seconds = String(indianShiftTime.getSeconds()).padStart(2, '0');
        const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return formattedTime;
    }

    convertShiftTime(currentShiftTime, targetTimezoneString) {
        if (currentShiftTime !== null) {

            const utcMatch = targetTimezoneString.match(/UTC\s?([-+]\d+):(\d+)/);
            if (!utcMatch) {
                throw new Error("Invalid timezone string format");
            }
            
            const targetHoursOffset = parseInt(utcMatch[1], 10);
            const targetMinutesOffset = parseInt(utcMatch[2], 10);
            const targetTotalOffsetMinutes = targetHoursOffset * 60 + targetMinutesOffset;
            const currentOffsetMinutes = 5 * 60 + 30;
            const currentDate = new Date(currentShiftTime);
            const shiftUTC = currentDate.getTime() - currentOffsetMinutes * 60000;
            const targetShiftTime = new Date(shiftUTC + targetTotalOffsetMinutes * 60000);

            const day = targetShiftTime.getDate();
            const month = targetShiftTime.toLocaleString("default", { month: "short" });
            const year = targetShiftTime.getFullYear();
            const hours = targetShiftTime.getHours();
            const minutes = targetShiftTime.getMinutes();
            const formattedHours = hours % 12 || 12;
            const ampm = hours >= 12 ? "PM" : "AM";
            const formattedMinutes = String(minutes).padStart(2, "0");
            const formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
            const formattedDate = `${day} ${month} '${String(year).slice(2)}`; 
            const datedone = `${formattedTime} ,${formattedDate}`
            // console.log("Formatted Offset:", formattedOffset);
            return datedone;
        }
    }
    getHeader(headers) {
        // console.log(headers,"headers")
        return headers.map((head) => {
            return (
                <th  key={head} style={{ textAlign: "left" , background: "var(--Primary)" , color:"white" }}>{head}</th>
            )
        })
    }

    setRowsFromHeaders(data) {
        return (
            <>
                <td style={{ alignContent: "center" }}>
                    <div className="leaveStatus">
                        {this.setActionMessage(data, data.timezone)}
                    </div>
                </td>
                <td style={{ alignContent: "center" }}>
                    <div className="LeaveUserDescription">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className="image">
                                <GetImage key={data.empid} redirect={true} top={true} width={"32px"} height={"32px"} imgID={data.empid} />
                            </div>
                            <div className="descBox">
                                <p>{data.empname}</p>
                                <span>Applied On {this.convertShiftTime(data.raisedon.date, data.timezone)}</span>
                                <p>{this.getUTCOffset(data.timezone) !== this.getTimezoneString() && <div style={{ fontSize: "10px", fontStyle: "italic" , color:"gray" }}>{data.timezone}</div>}</p>
                            </div>
                        </div>
                        
                    </div>
                </td>
                <td style={{ alignContent: "center" }}>
                    <span style={{ alignContent: "center", fontSize: "14px" }}>{data.leavetype}</span>
                </td>
                <td style={{ alignContent: "center" }}>
                    <div className="Table_from_date">
                        <span><ArrowUpwardIcon /></span>
                        <span>{this.convertShiftTime(data.from.date, data.timezone)}

                            {this.getUTCOffset(data.timezone) !== this.getTimezoneString() && <div style={{ fontSize: "10px", fontStyle: "italic" }}>{data.timezone}</div>}
                        </span>
                    </div>
                    <div className="Table_to_date">
                        <span><ArrowDownwardIcon /></span>
                        <span>{this.convertShiftTime(data.to.date, data.timezone)}

                            {this.getUTCOffset(data.timezone) !== this.getTimezoneString() && <div style={{ fontSize: "10px", fontStyle: "italic" }}>{data.timezone}</div>}
                        </span>
                    </div>
                </td>
                <td style={{ alignContent: "center" }}>
                    <span style={{ alignContent: "center", fontSize: "14px" }}>{data.reason}</span>
                </td>
                <td style={{ alignContent: "center" }}>
                    {
                        data.substituteempid !== -1 && <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <div>
                                <GetImage key={data.substituteempid} redirect={true} top={true} width={"32px"} height={"32px"} imgID={data.substituteempid}  />
                            </div>
                            <div>
                                <span style={{ fontSize: "14px" }}>{data.substituteempname}</span>
                            </div>
                        </div>
                    }

                </td>
                <td style={{ alignContent: "center" }}>
                    <span style={{ alignContent: "center", fontSize: "14px", fontWeight: "bold" }}>{data.totaldays}</span>
                </td>
                <td style={{ alignContent: "center" }}>
                    {
                        data.allowdelete == 1 ?
                            <IconButton onClick={() => this.DeleteLeave(data.leaveid)}>
                                <DeleteIcon style={{ color: "var(--Overtime)" }} />
                            </IconButton>
                            : ""
                    }
                </td>
            </>
        )
    }
    getLeaveList(recid) {
        if (recid == -1) {
            this.setState({ isApiHitComplete: false })
        }
        let obj = {
            'query': `HRApp_Droid_Proc_User_Leave_GetList @UserID='{0}',@EmpID='{1}',@PageRecID='{2}'`,
            'queryArr': [`${this.props.userid}`, `${this.state.EmpID}`, `${recid}`]
        }
        this.setState({ selectedTab: 'All', isBoradcastListFound: false })
        Hexapi(obj).then((resp) => {
            console.log(resp, "resp")
            if (resp[''].length > 0 && resp[''] != undefined) {
                if (resp[''].length < this.state.leaveListLength) {
                    this.setState({ isLastList: true })
                } else {
                    this.setState({ isLastList: false, leaveListLength: resp[''].length })
                }
                if (recid != '-1') {
                    this.setState({
                        allLeaves: this.state.allLeaves.concat(resp['']),
                        isLeaveListFound: true
                    })
                } else {
                    this.setState({
                        allLeaves: resp[''],
                        isLeaveListFound: true
                    })
                }
            } else {
                if (resp[''].length < this.state.leaveListLength) {
                    this.setState({ isLastList: true, isLeaveListFound: true })
                } else {
                    this.setState({ isLastList: false, isLeaveListFound: false })
                }
              
            }
        }).then(resp => this.setState({ isApiHitComplete: true })).catch(err => console.error(err))
    }
   async closeApplyLeaveModal() {
        
const result = await showConfirm({
            content:'Are you sure you want to discard this leave?',
            hideCancel:false,
            okText:"Yes",
            cancelText:"No"
        })

        if(result){
            this.setState({
                            isOpenAddLeaveModal: false,
                            selectedLeaveTypeID: '',
                            selectedLeaveTypeName: '',
                            selectedFromDateString: '',
                            selectedFromDateLogTime: '',
                            selectedToDateLogTime: '',
                            selectedToDateString: '',
                            OLCmsg: '--',
                            selectedApproverId: '',
                            selectedApproverName: '',
                            reason: '',
                            timezone: "",
                            selectedLeaveforName: "",
                            selectedLeaveforID: this.state.defaultEmpid,
                            EmpID: this.state.defaultEmpid,
                            selectedsubstituteName: "",
                            selectedsubstituteID: ""
                        })
        }
    }
    openLeaveTypeModal() {
        this.setState({ isLeaveTypeModal: true })
    }
    openLeavefor() {
        this.setState({ isLeaveForModal: true })
    }
    updateHeader = () => {
    const { EmpID, Username } = this.state;
    const { userid } = this.props;

    if (!EmpID || !userid ) return;

    let newName = "";

    if (EmpID == userid) {
        newName = "";
        // newName = "Your";
    } else {
        newName = Username + "'s";
    }

    const data = { header: `${newName} Leaves` };
console.log(data,"dattfshadssas")
    const event = new CustomEvent("myCustomEvent", {
        detail: data
    });

    window.parent.document.dispatchEvent(event);
};

   
componentDidMount() {

    if (this.state.action !== '') {
        this.getaction(window.location.search);
    }
if(this.props.userid){
    this.updateHeader();
}
    if (this.props.userid && this.state.EmpID) {
        this.getLeaveList('-1');
    }
}


componentDidUpdate(prevProps, prevState) {

    if (
        this.state.action == "1" &&
        prevState.action !== this.state.action
    ) {
        this.Addleave();
        this.setState({ action: "" });
    }

   if (prevProps.userid !== this.props.userid) {
        this.setState(
            { userid: this.props.userid },
            () => {
                this.updateHeader();
            }
        );
        return;
    }

    if (
        prevState.EmpID !== this.state.EmpID ||
        prevState.Username !== this.state.Username
    ) {
        this.updateHeader();
    }
   
    if (prevProps.userid !== this.props.userid) {
        this.setState({
            userid: this.props.userid
        });
    }
}

    setFullDateString(logtime) {
        if (logtime != null && logtime != "" && logtime != undefined) {
            if (logtime.date != undefined) {
                let dateObj = TimeFormatter(logtime.date,3)
                // console.log(dateObj)
                let str = `${dateObj.ShiftTime}, ${dateObj.userSplitedDate[2]} ${dateObj.ShiftMonth}'${dateObj.userSplitedDate[0].slice(-2)}`
                return str
            } else {
                let dateObj = TimeFormatter(logtime,3)
                // console.log(dateObj)
                let str = `${dateObj.ShiftTime}, ${dateObj.userSplitedDate[2]} ${dateObj.ShiftMonth}'${dateObj.userSplitedDate[0].slice(-2)}`
                return str
            }
        }
    }
    setActionMessage(leave, timezone) {
        console.log(leave, "leavefguyc")
        let showapprovedImg = false
        let approverImgId = ''
        let color = ''
        let setApprovalTxt = ""
        let acceptImg = ''
        let rejectImg = ''
        if (leave.approvalstage == "0") {
            showapprovedImg = true
            approverImgId = leave.approvalempid
            color = 'black'
            setApprovalTxt = `Pending With ${leave.approvalempid == this.state.userid ? "You" : leave.approvalempname}`
        }
        else if (leave.approvalstage == "1") {
            showapprovedImg = true
            acceptImg = true
            color = 'var(--Work)'
            setApprovalTxt = (
                <div>
                    <div style={{ fontSize: "1rem", color: "black" }}>
                        {leave.remarks
                        }
                    </div>
                    Accepted By {leave.approvalempid === this.state.userid ? "You" : leave.approvalempname} {leave.approvedon ? `on ${this.convertShiftTime(leave.approvedon.date, timezone)}`:""} 

                    {this.getUTCOffset(timezone) !== this.getTimezoneString() && (
                        <div style={{ fontSize: "10px", fontStyle: "italic" }}> {timezone} </div>
                    )}
                </div>
            );
        } else {
            showapprovedImg = true
            rejectImg = true
            color = 'var(--Overtime)'
            setApprovalTxt = (<div>
                <div style={{ fontSize: "1rem", color: "black" }}>
                    {leave.remarks
                    }
                </div>
                Rejected By {leave.approvalempid == this.state.userid ? "You" : leave.approvalempname} {leave.approvedon ?`on ${this.convertShiftTime(leave.approvedon.date, timezone)}` :""} 

                {this.getUTCOffset(timezone) !== this.getTimezoneString() && <div style={{ fontSize: "10px", fontStyle: "italic" }}>{timezone}</div>}
            </div>)
        }
        return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div>
                    {
                        acceptImg ?
                            <div style={{ background: "var(--Work)", width: "30px", height: "30px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <CheckIcon style={{ color: "#fff", fontSize: "16px" }} />
                            </div>
                            :
                            rejectImg ?
                                <div style={{ background: "var(--Overtime)", width: "30px", height: "30px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <CloseIcon style={{ color: "#fff", fontSize: "16px" }} />
                                </div>
                                :
                                approverImgId ?
                                    <GetImage key={approverImgId} redirect={true} top={true} width={"32px"} height={"32px"} imgID={approverImgId}  />
                                    : null
                    }
                </div>

                <div>

                    <div style={{ color: color }}> {setApprovalTxt}
                    </div>
                </div>

            </div>
        )
    }
    Addleave() {
        if(this.props.userid && this.state.EmpID){
        let obj = {
            'query': `HRApp_Droid_Proc_AddLeave_GetFormData @EmpID='{0}',@UserID='{1}'`,
            'queryArr': [`${this.state.EmpID}`, `${this.props.userid}`]
        }
        this.setState({ isModalLoading: true })
        Hexapi(obj).then((resp) => {
            console.log(resp,"resp")
            if (resp.leavefordetails) {
                const selectedleavefor = resp.leavefordetails.find(
                    (leavefor) => leavefor.empid == Number(this.state.EmpID)
                );
                console.log(selectedleavefor, "selectedleavefor")

                const filledbyOptions=resp.leavefordetails&& resp.leavefordetails.map((leavefor) => ({
                    value: leavefor.empid,
                    label: leavefor.empname
                }));

                this.setState({
                    leaveforlist: filledbyOptions,
                    selectedLeaveforName: selectedleavefor.empname
                })
            }
            if (resp.shiftdetails[0].checkintime != null && resp.shiftdetails[0].checkouttime != null) {
                this.setState({
                    timezone: resp.shiftdetails[0].timezone
                })

                const datefrom = this.convertToFullDateTime(resp.shiftdetails[0].checkintime, resp.shiftdetails[0].timezone)
                const dateto = this.convertToFullDateTime(resp.shiftdetails[0].checkouttime, resp.shiftdetails[0].timezone)

                this.setState({
                    selectedToDateLogTime: dateto,
                    selectedFromDateLogTime: datefrom
                })
            }
            if (resp.approvaldetails.length == 1) {
                this.setState({ isApproverListDisable: true, selectedApproverName: resp.approvaldetails[0].empname, selectedApproverId: resp.approvaldetails[0].empid })
            } else {
                this.setState({ isApproverListDisable: false })
            }
  const filledbyOptionsAllApprovers=resp?.approvaldetails&& resp.approvaldetails.map((leavefor) => ({
                    value: leavefor.empid,
                    label: leavefor.empname
                }))


  const filledbyOptionssubstitute=resp?.substitute&& resp.substitute.map((leavefor) => ({
                    value: leavefor.empid,
                    label: leavefor.empname
                }));
            this.setState({
                AllLeaveTypes: resp.leavetype,
                substitutelist: filledbyOptionssubstitute,
                AllApprovers: filledbyOptionsAllApprovers,
                shiftDetails: resp.shiftdetails[0],
                isModalLoading: false, isOpenAddLeaveModal: true
            })
        }).catch(err => console.error(err))
    }
}
    setOLC(fromDate, toDate, leavetypeid) {
        if(this.state.EmpID=="" || this.state.EmpID==null || this.state.EmpID==undefined && this.props.userid){
            
            showConfirm({
                content: 'Please select valid employee for leave',
            })
            return;
        }
        this.setState({ isOLCapihitcomplete: false })
        let obj = {
            'query': `HRApp_Droid_Proc_AddLeave_FromToOLC @UserID='{0}',@EmpID='{1}',@From='{2}',@To='{3}',@LeaveTypeID='{4}'`,
            'queryArr': [`${this.props.userid}`, `${this.state.EmpID}`, `${fromDate}`, `${toDate}`, `${leavetypeid}`]
        }
        Hexapi(obj).then((resp) => {
            console.log(resp)
            this.setState({ OLCmsg: resp[''][0].msg })
        }).then(re => this.setState({ isOLCapihitcomplete: true })).catch(err => console.error(err))

    }
    setLeaveType(data) {
        this.setState({
            selectedLeaveTypeName: data.leavetype,
            selectedLeaveTypeID: data.leavetypeid,
            isLeaveTypeModal: false,
        })
        let fromdate = "-1"
        let todate = "-1"
        if (this.state.selectedFromDateString != "") {
            fromdate = this.state.selectedFromDateLogTime
        }
        if (this.state.selectedToDateString != "") {
            todate = this.state.selectedToDateLogTime
        }
        this.setOLC(fromdate, todate, data.leavetypeid)
    }

    setLeavefor(empid, empname) {
        if (empid == undefined || empid == null || empid == "") {
            alert("Invalid employee")
            return;
        } else {
            this.setState({
                selectedLeaveforName: empname,
                selectedLeaveforID: "",
                isOpenleaveforListModal: false,
                EmpID: empid,
                selectedApproverName: "",
                selectedApproverId: "",
                selectedLeaveTypeName: "",
                selectedLeaveTypeID: "",
                selectedsubstituteName: "",
                selectedsubstituteID: "",
                reason: ""

            }, () => {
                let fromdate = "-1"
                let todate = "-1"
                if (this.state.selectedFromDateString != "") {
                    this.setState({
                        selectedFromDateString: ""
                    })
                }
                if (this.state.selectedToDateString != "") {
                    this.setState({
                        selectedToDateString: "",

                    })
                }

                this.setOLC(fromdate, todate, empid)
                this.Addleave()
            })
        }


    }


    setsubstitute(empid, empname) {
        this.setState({
            selectedsubstituteName: empname,
            selectedsubstituteID: empid,
            opensubstitutemodal: false,
        })
    }



    storeFromDate(date) {

        let fromDate = new Date(date);
        let toDate = new Date(this.state.selectedToDateLogTime);
        toDate.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());

        const formatDate = (date) => {
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');
            let hours = date.getHours().toString().padStart(2, '0');
            let minutes = date.getMinutes().toString().padStart(2, '0');
            let seconds = date.getSeconds().toString().padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        let formattedToDate = formatDate(toDate);
        this.setState({
            selectedToDateLogTime: formattedToDate,
        }, () => {
            this.setState({ openFromdatamodal: false, selectedFromDateLogTime: date, selectedFromDateString: this.setFullDateString(date), isOLCapihitcomplete: false })
            if (this.state.selectedLeaveTypeID == "") {
                console.log("hello")
                let leavetypeid = '-1'
                let fromdate = date
                let todate = "-1"
                if (this.state.selectedToDateString != "") {
                    if (date > this.state.selectedToDateLogTime) {
                        console.log()
                        this.setState({ selectedToDateLogTime: '', selectedToDateString: '' })
                        todate = "-1"
                    } else {
                        todate = this.state.selectedToDateLogTime
                    }
                }
                this.setOLC(fromdate, todate, leavetypeid)

            } else {
                console.log("heyy")
                console.log(this.state.selectedToDateLogTime, "selectedlogtime88")
                let leavetypeid = this.state.selectedLeaveTypeID
                let fromdate = date
                let todate = "-1"
                if (this.state.selectedToDateString != "") {
                    console.log(this.state.selectedToDateLogTime, "selectedlogtime55")
                    if (date > this.state.selectedToDateLogTime) {
                        console.log(this.state.selectedToDateLogTime, "selectedlogtime66")
                        this.setState({ selectedToDateLogTime: '', selectedToDateString: '' })
                        todate = "-1"
                    } else {
                        console.log(this.state.selectedToDateLogTime, "selectedlogtime77")
                        todate = this.state.selectedToDateLogTime
                    }
                }
                this.setOLC(fromdate, todate, leavetypeid)

            }
        });



    }
    storeToDate(date) {

        if (date < this.state.selectedFromDateLogTime) {
            alert('To Date cannot be before from Date')
            this.setState({
                opentodatamodal: false,
                // selectedToDateLogTime: this.state.selectedFromDateLogTime,
                selectedToDateString: ''
            })
            let leavetypeid = this.state.selectedLeaveTypeID
            let fromdate = this.state.selectedFromDateLogTime
            let todate = '-1'
            if (this.state.selectedLeaveTypeName == "") {
                leavetypeid = '-1'
            }
            this.setOLC(fromdate, todate, leavetypeid)
        } else {
            this.setState({
                opentodatamodal: false,
                selectedToDateLogTime: date,
                selectedToDateString: this.setFullDateString(date),
            })
            let leavetypeid = this.state.selectedLeaveTypeID
            let fromdate = this.state.selectedFromDateLogTime
            let todate = date
            if (this.state.selectedLeaveTypeName == "") {
                leavetypeid = '-1'
            }
            this.setOLC(fromdate, todate, leavetypeid)
        }

    }
    openApproverList(e) {
        this.setState({
            isOpenApproversListModal: true
        })
    }
    selectApprover(empid, empname) {
        console.log(empid, empname)
        this.setState({
            selectedApproverId: empid,
            selectedApproverName: empname,
            isOpenApproversListModal: false
        })
    }
    submitLeave() {
        if (this.state.selectedLeaveTypeName != '') {
            if (this.state.selectedFromDateString != '') {
                if (this.state.selectedToDateString != '') {
                    if (this.state.selectedsubstituteID !== "" && this.state.selectedsubstituteName !== "") {
                        if (this.state.selectedApproverName != "") {
                            if (this.state.reason != "") {
                                let obj = {

                                    'query': `HRApp_Droid_Proc_AddLeave_Submit @EmpID='{0}',@UserID='{1}',@ApprovalEmpID='{2}',@From='{3}',@To='{4}',@Reason='{5}',@LeaveTypeID='{6}',@SubstituteEmpID='{7}'`,
                                    'queryArr': [`${this.state.EmpID}`, `${this.state.userid}`, `${this.state.selectedApproverId}`, `${this.convertToIndianTime(this.state.selectedFromDateLogTime, this.state.timezone)}`, `${this.convertToIndianTime(this.state.selectedToDateLogTime, this.state.timezone)}`, `${this.state.reason}`, `${this.state.selectedLeaveTypeID}`, `${this.state.selectedsubstituteID}`]
                                }
                               
                                this.setState({ isModalLoading: true })
                                Hexapi(obj).then((resp) => {
                                    console.log(resp)
                                    this.setState({ isModalLoading: false })
                                  showConfirm({
                                        content:resp[''][0].msg,
                                        okText:"OK",
                                        hideCancel:true
                                    })
                                    .then(() => {
                                        if (resp[''][0].command == 1) {
                                            this.setState({ isOpenAddLeaveModal: false })

                                            this.setState({
                                                selectedLeaveTypeID: '',
                                                selectedLeaveTypeName: '',
                                                selectedFromDateString: '',
                                                selectedFromDateLogTime: '',
                                                selectedToDateLogTime: '',
                                                selectedToDateString: '',
                                                OLCmsg: '--',
                                                selectedApproverId: '',
                                                selectedApproverName: '',
                                                reason: '',
                                                timezone: "",
                                                selectedLeaveforName: "",
                                                selectedLeaveforID: "",
                                                EmpID: this.state.defaultEmpid,
                                                selectedsubstituteName: "",
                                                selectedsubstituteID: "",
                                                substitutelist: [],
                                            }, () => {
                                                this.getLeaveList('-1')
                                            })
                                        }
                                    })
                                }).catch(err => console.error(err))
                            } else {
                                alert('Enter reason')
                            }
                        } else {
                            alert('select approver')
                        }

                    } else {
                        alert('Select substitute')
                    }
                } else {
                    alert('Select to date')
                }
            } else {
                alert('Select from date')
            }
        } else {
            alert('Select leave type')
        }
    }
    async DeleteLeave(leaveid) {
        const result=await showConfirm({
            content:'Are you sure you want to delete this leave request? ',
            hideCancel:false,
            okText:"Yes",
            cancelText:"Cancel"
        })

        if( result){
if(!this.props.userid || !this.state.EmpID) return;
                        let obj = {
                            'query': `HRApp_Droid_Proc_DeleletLeave_Submit @UserID='{0}',@EmpID='{1}',@LeaveID='{2}'`,
                            'queryArr': [`${this.props.userid}`, `${this.state.EmpID}`, `${leaveid}`]
                        }
                        this.setState({ isModalLoading: true })
                        Hexapi(obj).then((resp) => {
                            console.log(resp)
                            this.setState({ isModalLoading: false })
                            // Swal.fire({
                            //     confirmButtonColor: '#28b6f6',
                            //     text: resp[''][0].msg,
                            // })
                            showConfirm({
                                content: resp[''][0].msg,
                                hideCancel: true,
                            })
                            .then(() => {
                                if (resp[''][0].command == 1) {
                                    this.setState({ isOpenAddLeaveModal: false })
                                    this.getLeaveList('-1')
                                }
                            })
                        }).catch(err => console.error(err))
        }
       
    }
    render() {

        return (
            <div className="leavemainouter_box">
                <div className="main_box">
                    {/* Leave Tile Start */}
                    {
                        this.state.isApiHitComplete ?
                            this.state.isLeaveListFound ?
                                <div id="myReportTableleave">
                                    <Table responsive >
                                        <thead>
                                            <tr style={{ background: "var(--Primary)", border: "none", color: "white", position: "sticky", top: "0px", zIndex: '1' }}>
                                                {this.getHeader(this.state.headers.Leave)}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.allLeaves.map((leave, index) => {
                                                    return (
                                                        <>
                                                            <VisibilitySensor
                                                                onChange={(isVisible) => {
                                                                    if (index == this.state.allLeaves.length - 1 && isVisible) {
                                                                        if (!this.state.isLastList) {
                                                                            this.getLeaveList(leave.recid)
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <tr key={index} style={{ alignContent: "center" }}>
                                                                    {this.setRowsFromHeaders(leave)}
                                                                </tr>
                                                            </VisibilitySensor>
                                                            {
                                                                (index == Object.keys(this.state.allLeaves).length - 1) ?
                                                                    !this.state.isLastList ?
                                                                        <tr>
                                                                            <td colspan={6} style={{ textAlign: "center" }}>
                                                                                <Loader/>
                                                                            </td>
                                                                        </tr>
                                                                        :
                                                                        ""
                                                                    :
                                                                    ""
                                                            }
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                                :
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: '100%', height: "100vh" }}>
                                    <h5 style={{ color: 'orange' }}>No Leave Found!</h5>
                                </div>
                            :
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: '100%', height: "100vh" }}>
                               <Loader/>
                            </div>
                    }
                    <div className="footerdivleave">
                        <div className="addleaveBtn" onClick={() => this.Addleave()}>
                            {/* <AddIcon/> */}
                            <LuPlus style={{ marginBottom:"2px", marginRight: "3px", fontWeight: "bold", fontSize: "18px" }} /><span>LEAVE</span> 
                        </div>
                    </div>
                </div>

                <Modal className='LoadingModal' size="sm" centered style={{ backdropFilter:"blur(6px)"}} show={this.state.isModalLoading} onHide={() => this.setState({ isModalLoading: false })}>
                    <Modal.Body>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                           <Loader/>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal className='leaveformmodal' size="md" centered style={{ backdropFilter:"blur(6px)" }} show={this.state.isOpenAddLeaveModal} onHide={() => this.closeApplyLeaveModal()}>
                    <Modal.Header style={{ paddingTop: "5px", paddingBottom: "5px" , display:"flex" , justifyContent:"space-between"  }} >
                        <p style={{ fontSize: "18px", color: "#0cc1e6", marginBottom: "0px" }}>Apply Leave</p>
                        <IconButton onClick={() => this.closeApplyLeaveModal()}>
                            <CloseIcon />
                        </IconButton>
                    </Modal.Header>
                    <Modal.Body style={{ paddingBottom: "3px", paddingTop: "3px" }}>
                        <div className="form">
                            <InputBox
                             labelStyle={{  color:"black" , fontWeight:"500"}}
                                htmlFor={"Leavefor"}
                                label={"Leave For"}
                                type="text"
                                placeholder={`Select leave for`}
                                value={this.state.selectedLeaveforName}
                                onClick={(e) => this.setState({ isOpenleaveforListModal: true })}
                                required={true}
                                
                                readOnly={true}
                            />
                            <InputBox
                                labelStyle={{  color:"black" , fontWeight:"500"}}
                                htmlFor={"Leavetype"}
                                label={"Leave Type"}
                                type="text"
                                placeholder={`Select leave type`}
                                value={this.state.selectedLeaveTypeName}
                                onClick={(e) => this.openLeaveTypeModal()}
                                required={true}
                                readOnly={true}
                            />
                            {this.getUTCOffset(this.state.timezone) !== this.getTimezoneString() &&
                                <div>

                                     <InputBox
                                       labelStyle={{ backgroundColor:"white", color:"gray" , fontWeight:"500"}}
                                        htmlFor={"Timezone"}
                                        label={"Timezone"}
                                        inputStyle={{ border:"none", paddingTop:"0px",color: "gray", fontStyle: "italic" }}
                                        type="text"
                                        // placeholder={`Select date`}
                                        value={this.state.timezone}
                                        required={true}
                                        readOnly={true}
                                        disabled={true}
                                    />
                                    {/* <label style={{ color: "gray", fontSize: "16px" }} htmlFor="timezone">Timezone<span style={{ color: "red", fontSize: "18px", fontWeight: "600" }}>*</span></label>
                                    <input
                                        id="timezone"
                                        className='form-control mb-2'
                                        style={{ border:"none", paddingTop:"0px", backgroundColor: "white", color: "gray", paddingLeft: "4px", fontSize: "14px", fontStyle: "italic" }}
                                        type="text"
                                        value={this.state.timezone}
                                        required={true}
                                        readOnly={true}
                                        disabled={true} /> */}
                                </div>

                            }


                            <div className="selectDate" style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                <div className="fromDate" style={{ width: "48%" }}>
                                    <InputBox
                                     labelStyle={{  color:"black" , fontWeight:"500"}}
                                        htmlFor={"fromdate"}
                                        label={"From Date"}
                                        type="text"
                                        placeholder={`Select date`}
                                        value={this.state.selectedFromDateString}
                                        onClick={(e) => this.setState({ openFromdatamodal: true })}
                                        required={true}
                                        readOnly={true}
                                    />
                                </div>
                                <div className="toDate" style={{ width: "48%" }}>
                                    <InputBox
                                     labelStyle={{  color:"black" , fontWeight:"500"}}
                                        htmlFor={"todate"}
                                        label={"To Date"}
                                        type="text"
                                        placeholder={`Select date`}
                                        value={this.state.selectedToDateString}
                                        onClick={(e) => {
                                            if (this.state.selectedFromDateString != "") {
                                                this.setState({ opentodatamodal: true })
                                            } else {
                                                alert('From date not selected')
                                            }
                                        }}
                                        required={true}
                                        readOnly={true}
                                    />
                                </div>
                            </div>
                            <div className="CalculatedDaysCount">
                                {
                                    this.state.isOLCapihitcomplete ?
                                        <span dangerouslySetInnerHTML={{ __html: this.state.OLCmsg }} />
                                        :
                                        <Loader/>
                                }
                            </div>
                            <InputBox
                             labelStyle={{  color:"black" , fontWeight:"500"}}
                                htmlFor={"substitute"}
                                label={"Substitute"}
                                type="text"
                                placeholder={`Select substitute`}
                                value={this.state.selectedsubstituteName}
                                onClick={(e) => this.opensubstituteList(e)}
                                required={true}
                                readOnly={true}
                            // disabled={this.state.isApproverListDisable}
                            />
                            <InputBox
                             labelStyle={{  color:"black" , fontWeight:"500"}}
                            inputStyle={{ backgroundColor: 'white', color:this.state.isApproverListDisable ? "gray" : "white"}}
                                htmlFor={"approver"}
                                label={"Approver"}
                                type="text"
                                placeholder={`Select approver`}
                                value={this.state.selectedApproverName}
                                onClick={(e) => this.openApproverList(e)}
                                required={true}
                                readOnly={true}
                                disabled={this.state.isApproverListDisable}
                            />
                            <InputBox
                             labelStyle={{  color:"black" , fontWeight:"500"}}
                                wordboundation={{ limit: 200, id: 'reasonInput' }}
                                htmlFor={"Reason"}
                                label={"Reason"}
                                type="text"
                                placeholder={`Enter reason`}
                                value={this.state.reason}
                                onChange={(e) => this.setState({ reason: e.target.value })}
                                required={true}
                            />
                        </div>
                        <div className="footer">
                            <span onClick={() => this.submitLeave()}>Apply</span>
                        </div>
                    </Modal.Body>
                </Modal>
                {/* Apply Leave Form end */}

                {/* Leave type modal start */}
                <Modal className='LeavetypeModal' size="sm" centered style={{ backdropFilter:"blur(6px)" }} show={this.state.isLeaveTypeModal} onHide={() => this.setState({ isLeaveTypeModal: false })}>
                    <Modal.Header closeButton>
                        <p style={{ fontSize: "18px", color: "#0cc1e6", marginBottom: "0px" }}>Select Leave Type</p>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="leavetypemodalList">
                            {
                                this.state.AllLeaveTypes &&
                                this.state.AllLeaveTypes.map((data, index) => {
                                    return (
                                        <span key={data.leavetypeid} onClick={() => this.setLeaveType(data)}>{data.leavetype}</span>
                                    )
                                })
                            }
                        </div>
                    </Modal.Body>
                </Modal>
                {/* Leave type modal end */}

                {/* FromDate picker modal start */}
                {this.state.openFromdatamodal && <Datetimepicker
                    openDateTimePicker={this.state.openFromdatamodal}
                    onHide={() => this.setState({ openFromdatamodal: false })}
                    onChange={(date) => this.storeFromDate(date)}
                    defaults={this.state.selectedFromDateLogTime}
                />}

                {this.state.opentodatamodal &&
                    <Datetimepicker
                        openDateTimePicker={this.state.opentodatamodal}
                        onHide={() => this.setState({ opentodatamodal: false })}
                        onChange={(date) => this.storeToDate(date)}
                        defaults={this.state.selectedToDateLogTime}
                    />}
                  {
                    this.state.AllApprovers.length >0 && 
                    <Empmodal selecttext="Select Approver"  onChange={(id, name) => this.selectApprover(id, name)} show={this.state.isOpenApproversListModal}  handleclose={() => this.setState({ isOpenApproversListModal: false })} data={this.state.AllApprovers} />
                }

                {
                    this.state.leaveforlist.length >0 && 
                    <Empmodal selecttext="Select Leave For"  onChange={(id, name) => this.setLeavefor(id, name)} show={this.state.isOpenleaveforListModal}  handleclose={() => this.setState({ isOpenleaveforListModal: false })} data={this.state.leaveforlist} />
                }
           
                   {
                    this.state.substitutelist.length >0 && 
                    <Empmodal selecttext="Select Substitute"  onChange={(id, name) => this.setsubstitute(id, name)} show={this.state.opensubstitutemodal}  handleclose={() => this.setState({ opensubstitutemodal: false })} data={this.state.substitutelist} />
                }
            </div>
        )
    }
}
export default withRouter(Leave)